const HomePhilosophy = () => {
  return (
    <section className="py-32 px-6 relative overflow-hidden bg-gradient-to-br from-gray-50 via-white to-slate-100 dark:from-gray-900 dark:via-gray-800 dark:to-black">
      <div className="absolute inset-0 opacity-10 dark:opacity-5">
        <div className="absolute top-1/3 left-1/3 w-72 h-72 bg-gradient-radial from-gray-300/40 via-transparent to-transparent" />
        <div className="absolute bottom-1/3 right-1/3 w-64 h-64 bg-gradient-radial from-slate-300/40 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto text-center">
        <p className="text-xs font-light tracking-[0.4em] uppercase text-gray-400 dark:text-gray-500 mb-8">
          The Philosophy of Intelligent Style
        </p>
        <h2 className="text-4xl md:text-5xl font-thin mb-8 text-gray-900 dark:text-white leading-tight">
          Where Innovation
          <br />
          <span className="italic font-extralight bg-gradient-to-r from-gray-600 via-slate-500 to-gray-700 dark:from-gray-300 dark:via-gray-200 dark:to-gray-400 bg-clip-text text-transparent">
            Meets Intuition
          </span>
        </h2>
        <div className="w-32 h-px bg-gradient-to-r from-transparent via-gray-300 dark:via-gray-600 to-transparent mx-auto mb-16" />
      </div>
    </section>
  );
};

export default HomePhilosophy;
